import { FetchGridParameters } from 'shared';

export const DEFAULT_PAGE_PARAMS: FetchGridParameters<unknown> = {
  page: 1,
  pageSize: 10,
  order: 'asc',
};

export const DEFAULT_PAGE_SIZE_OPTIONS = [10, 20, 50, 100];
